export const MODEL_USER = "model";
export const LESSON = "kitList";

export const ALLOWED_LESSONS = [LESSON];
